import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";

import { queriesEnabledAtom, tenantIDAtom } from "../../../atoms/GlobalAtoms";
import BrieConversationAPI from "../../../api/api/BrieConversationAPI";
import { BrieGPTProject } from "./useBrieGPTItems";

export default function useBrieGPTProjects(projectID: string | null) {
  const queriesEnabled = useAtomValue(queriesEnabledAtom);
  const tenantID = useAtomValue(tenantIDAtom);

  const project = useQuery({
    queryKey: ["BrieGPTProject", tenantID, projectID],
    queryFn: () =>
      BrieConversationAPI.getBrieGPTProject(projectID || "").then((res) => {
        const project = res?.data?.data?.project;

        return project;
      }),
    enabled: queriesEnabled && !!projectID,
  });

  return {
    project: project.data as BrieGPTProject | null,
    projectLoading: project.isLoading,
  };
}
